import script from "./modalComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./modalComponent.vue?vue&type=script&lang=ts&setup=true"

import "./modalComponent.scss?vue&type=style&index=0&lang=scss"

const __exports__ = script;

export default __exports__